import type { FC } from 'react';
import { memo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { useAppSelector } from '../../../../front/src/redux/hooks';
import { selectHeadings } from '../../../../front/src/thread/ThreadMessage/topics-slice';
import type { Category } from '../../../../front/src/types/api';
import type { ReadersForumBlockData } from '../../../../front/src/types/layout';
import { SectionHead } from './press/pressShared';
import { ReadersForumCard } from './ReadersForumCard';

// "Le forum des lecteurs" — home block (bottom of media home) exposing the community
// space: a grid of rubrique cards (image + title + category chips), "façon Psychologies"
// (D-A5, B4_03). Media mode only (gated in Block.tsx). Rubriques come from selectHeadings
// (SSR-hydrated), so there is no server data on the block itself.

// graphdebate i18n source = en-US: defaultMessage must be English (fr-FR is a Loco translation).
export const readersForumMessages = defineMessages({
  title: { defaultMessage: 'The readers’ forum', id: 'LDjRBg' },
});

interface Props {
  block: ReadersForumBlockData;
}

export const ReadersForumBlock: FC<Props> = memo(function ReadersForumBlock() {
  const headings = useAppSelector(selectHeadings);

  // NewHeadingsMenu never returns null on an empty list, so this block owns the guard:
  // no rubrique → render nothing (same contract as readers-circle without a circle).
  if (!headings?.length) return null;

  return (
    <section className="ReadersForumBlock max-w-5xl mx-auto px-7 pt-16">
      <SectionHead title={<FormattedMessage {...readersForumMessages.title} />} />
      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {headings.map(heading => (
          <ReadersForumCard
            key={heading.uid}
            title={heading.content as string}
            tags={heading.children as (Category | null)[]}
            background={heading.background as string}
            color={heading.color}
          />
        ))}
      </ul>
    </section>
  );
});
